import { Button, Card, Center, Container, Group, Image, Input, PasswordInput, Stack, Text, TextInput } from "@mantine/core";
import { useInputState } from "@mantine/hooks";
import "./LoginPage.css";
import { useState } from "react";
import { AuthenticationManager } from "common";
import UserProfileService from "../../services/UserProfileService";
import { useDispatch } from "react-redux";
import { login } from "../../store/features/authSlice";
import { addHours } from "date-fns";
import { useNavigate } from "react-router-dom";
import { notifications } from '@mantine/notifications';

const logoUrl = "https://img.icons8.com/external-others-phat-plus/64/000000/external-bell-hotel-and-travel-color-line-others-phat-plus.png";
export const TOKEN_EXP = addHours(new Date(), 1).getTime() / 1000;

const LoginPage = () => {
    const [ loading, setLoading ] = useState(false);
    const [ email, setEmail ] = useInputState("");
    const [ password, setPassword ] = useInputState("");
    const [ error, setError ] = useState({ email: "", password: "" });
    
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const loginHandler = async () => {
        try 
        {
            setLoading(true);
            // Get token
            const token = await AuthenticationManager.login(email, password);
            localStorage.setItem("token", token);
            
            // Get user profile
            let up = await UserProfileService.getUserProfile(token);

            dispatch(login({ ...up, token, expiration: TOKEN_EXP }));
            navigate("/");
        } 
        catch (error: any) 
        {
            console.log("[LoginPage.tsx - login()] - Login failed", error);

            if(error.message.includes("NotAuthorizedException"))
                setError(curr => ({ ...curr, email: "Email o password errate", password: " " }));
            else if(error.message.includes("UserNotFoundException"))
                setError(curr => ({ ...curr, email: "Utente non trovato"}));
            else
            {
                notifications.show({
                    color: 'red',
                    title: 'Login fallita',
                    message: error.message
                });
            }
        }
        finally
        {
            setLoading(false)
        }
    };

    return(
        <Container>
            <Center h={"100vh"}>
                <Card shadow="sm" padding="lg" radius="md" withBorder miw={350}>
                    <Stack>
                        <Center>
                            <Group>
                                <Image w={40} src={ logoUrl } />
                                <Stack gap={0}>
                                    <Text fw={700}>NowCheckin</Text>
                                    <Text c="dimmed" size="xs">Area Riservata</Text>
                                </Stack>
                            </Group>
                        </Center>

                        <TextInput variant="filled" placeholder="Email" value={ email } onChange={ setEmail } error={ error.email } />
                        <PasswordInput variant="filled" placeholder="Password" value={ password } onChange={ setPassword } error={ error.password } />

                        <Button 
                            variant="filled" 
                            color="orange" 
                            fullWidth 
                            loading={ loading }
                            onClick={ loginHandler } 
                        >
                            Login
                        </Button>
                    </Stack>
                </Card>
            </Center>
        </Container>
    );
};

export default LoginPage;